import script from "./CertificateDesignerWrapper.vue?vue&type=script&setup=true&lang=js"
export * from "./CertificateDesignerWrapper.vue?vue&type=script&setup=true&lang=js"

import "./CertificateDesignerWrapper.vue?vue&type=style&index=0&id=222a45d4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-222a45d4"]])

export default __exports__